import { ArrowDownLeft, ArrowUpRight, LucideIcon } from 'lucide-react';
import Option from '@/components/form/types/Option.ts';
import { TransactionDirection } from '@/features/dashboard/financialTransactions/types/TransactionDirection.ts';
import { TransactionAllocationType } from '@/features/dashboard/financialTransactions/types/TransactionAllocation.ts';

export const transactionDirectionLabels: Record<TransactionDirection, string> =
  {
    [TransactionDirection.INCOMING]: 'Wpłata od klienta',
    [TransactionDirection.OUTGOING]: 'Zapłata za wydatek',
  };

export const transactionDirectionOptions: Option[] = [
  {
    value: TransactionDirection.INCOMING,
    label: transactionDirectionLabels[TransactionDirection.INCOMING],
  },
  {
    value: TransactionDirection.OUTGOING,
    label: transactionDirectionLabels[TransactionDirection.OUTGOING],
  },
];

/** Transakcja jest jednorodna: wpłata idzie na rezerwacje, zapłata na wydatki. */
export const allocationTypeForDirection = (
  direction: TransactionDirection,
): TransactionAllocationType =>
  direction === TransactionDirection.OUTGOING
    ? TransactionAllocationType.EXPENSE
    : TransactionAllocationType.BOOKING;

/** Wiersz listy nie niesie kierunku, więc czytamy go ze znaku kwoty. */
export const getAmountDirection = (amount: number): TransactionDirection =>
  amount < 0 ? TransactionDirection.OUTGOING : TransactionDirection.INCOMING;

export const transactionDirectionIcons: Record<
  TransactionDirection,
  LucideIcon
> = {
  [TransactionDirection.INCOMING]: ArrowDownLeft,
  [TransactionDirection.OUTGOING]: ArrowUpRight,
};

/** Krótsze od etykiety formularza, bo czytnik ekranu czyta to obok kwoty. */
export const transactionDirectionAriaLabels: Record<
  TransactionDirection,
  string
> = {
  [TransactionDirection.INCOMING]: 'Wpłata klienta',
  [TransactionDirection.OUTGOING]: 'Zapłata za koszt',
};
